<ion-content class="bg-color ion-content update-category">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none; cursor: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>

        </li>
      </ul>
    </div>
    <div class="content-grid">
      <div class="m-content">
        <form [formGroup]="updateDatalakeEnvForm" (ngSubmit)="onSubmit()">
          <mat-card>
            <mat-card-title class="mc-title">
              <span class="org-header">Datalake Environment</span>
            </mat-card-title>
            <mat-card-content class="mc-content">
              <div class="form-container">
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Op Name</mat-label>
                    <input type="text" formControlName="op_name" matInput placeholder="Op Name" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>Op Type</mat-label>
                    <input type="text" formControlName="op_type" matInput placeholder="Op Type" required>
                  </mat-form-field>
                  </div>
                </div>
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>DL Version</mat-label>
                    <input type="text" formControlName="dlversion" matInput placeholder="DL Version" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>DL Host Name</mat-label>
                    <input type="text" formControlName="dlhost_name" matInput placeholder="DL Host Name" required>
                  </mat-form-field>
                  </div>
                </div>
                
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>DL Port</mat-label>
                    <input type="text" formControlName="dlport" matInput placeholder="DL Port" required>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>DL Username</mat-label>
                    <input type="text" formControlName="dlusername" matInput placeholder="DL Username" required>
                  </mat-form-field>
                  </div>
                </div>
                
                <div class="form-layout">
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>DL Password</mat-label>
                    <input [type]="hide ? 'password' : 'text'" formControlName="dlpsw" matInput placeholder="DL Password" required>
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </mat-form-field>
                  </div>
                  <div class="form-layout-view">
                  <mat-form-field appearance="outline">
                    <mat-label>DL Ca Certificate Path</mat-label>
                    <input type="text" formControlName="dl_ca_certs_path" matInput placeholder="DL Ca Certificate Path" required>
                  </mat-form-field>
                  </div>
                </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="margin-top-10">
              <mat-card-title class="mc-title">
                <h4 class="mat-title-header">Additional Information</h4>
              </mat-card-title>
              <mat-card-content class="mc-content">
                <div class="form-container">
                  <div class="list-info">
                    <span>Created By</span>
                    <span>{{categoryObj?.created_by}}</span>
                  </div>
                  <div class="list-info">
                    <span>Updated By</span>
                    <span>{{categoryObj?.updated_by}}</span>
                  </div>
                  <div class="list-info">
                    <span>Created Date</span>
                    <span>{{categoryObj?.created_date | date: 'medium'}}</span>
                  </div>
                  <div class="list-info">
                    <span>Updated Date</span>
                    <span>{{categoryObj?.updated_date | date: 'medium'}}</span>
                  </div>
                  <div class="list-info">
                    <span>Created IP Address</span>
                    <span>{{categoryObj?.created_ip_address}}</span>
                  </div>
                  <div class="list-info">
                    <span>Updated IP Address</span>
                    <span>{{categoryObj?.updated_ip_address}}</span>
                  </div>
                  <div class="btn-signup-grid">
                    <button mat-raised-button class="btn" routerLink="/baseapp/datalake-env">Cancel</button>
                    <button mat-raised-button type="submit" class="btn btn-signup">Update</button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </div>

      <app-about-page *ngIf="hide1200"></app-about-page>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
